import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { TSourceEmbedding } from '@core/api/sources/types';
import { SourcesService } from '@shared/services/sources.service';

import { EditReferencesModalComponent } from './edit-references-modal/edit-references-modal.component';

@Component({
    selector: 'app-source-embeddings',
    templateUrl: './source-embeddings.component.html',
    styleUrls: ['./source-embeddings.component.scss'],
    standalone: true,
    imports: [NgClass, MatChipListbox, MatChipOption, MatButton, MatProgressSpinner]
})
export class SourceEmbeddingsComponent {
  protected source: TSourceItem | undefined;
  protected embeddings: TSourceEmbedding[] = [];
  protected isLoadingEmbeddings = false;

  constructor(
    private _sourcesService: SourcesService,
    public dialog: MatDialog
  ) {}

  @Input() set sourceItem(source: TSourceItem) {
    this.source = source;
    this.isLoadingEmbeddings = true;
    this._sourcesService.getEmbeddings(this.source!._id).subscribe({
      next: res => {
        this.embeddings = res;
        this.isLoadingEmbeddings = false;
      },
      error: () => {
        this.isLoadingEmbeddings = false;
      },
    });
  }

  openReferenceModal(embedding: TSourceEmbedding) {
    this.dialog.open(EditReferencesModalComponent, {
      width: 'min(960px, calc(100vw - 24px))',
      maxWidth: '100vw',
      maxHeight: 'min(92vh, 900px)',
      autoFocus: 'first-tabbable',
      panelClass: 'edit-references-dialog-panel',
      data: { source: this.source, embedding },
    });
  }

  // New helper methods for formatting
  formatDate(date: Date | null | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString();
  }

  // New method to get status class
  getStatusClass(status: string): string {
    // Convert status to lowercase and remove spaces for CSS class
    const normalizedStatus = status?.toLowerCase().replace(/\s+/g, '-') || '';

    // Return the appropriate CSS class
    return `status-${normalizedStatus}`;
  }
}
